import { createContext, useContext } from 'react';
import type { CheckInCustomizationContext as Context } from './types';

const defaultContext: Context = {
  lastInjectionCount: null,
  askInjectionCount: false,
  checkInPrefill: null,
};

const ReactContext = createContext<Context>(defaultContext);

export const CheckInCustomizationProvider = ReactContext.Provider;

export const useCheckInCustomizationContext = (): Context =>
  useContext(ReactContext);
